<div [class]="companyFlavor + ' app-wrapper'">
  <router-outlet/>
</div>
